import { IonBadge } from '@ionic/react'
import React, { HTMLAttributes } from 'react'

export interface IBadge extends HTMLAttributes<HTMLIonBadgeElement> {
  count: number
  color?: string
  testId?: number | string
}

const BadgeComponent: React.FC<IBadge> = (props: IBadge) => {
  const { count, color, testId } = props

  return (
    <IonBadge data-testid={`BadgeCount${testId}`} color={color ? color : 'primary'} {...props}>
      {count}
    </IonBadge>
  )
}

export default BadgeComponent
